module.exports = __webpack_public_path__ + "img/3.b84b258a.jpg";